import React, { useState, useEffect } from 'react'
import { Panel, Grid, Row, Col, Timeline, Icon, Progress, Steps, Drawer, Button } from 'rsuite'
import { Link } from 'react-router-dom'
import style from './style.css'
import { downloadFileByPath, getEditContractRevise } from '../../redux/actions/contract'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { set } from 'nprogress'
import ProposalSendBackNew from '../proposalRevise/ProposalSendBackNew'
import { getProposalReviseNew } from '../../redux/actions/proposalRevise'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ProposalReviseView from '../../components/forms/proposalReviseForm/ProposalReviseView'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function ProjectProgressTimeline({ schema }) {
  const { Line } = Progress
  const [formSchema, setFormSchema] = useState(schema)
  const [showDrawer, setShowDrawer] = useState(false)
  const [showComment, setShowComment] = useState(false)

  const [reviseSchema, setReviseSchema] = useState()

  const styleIcon = {
    paddingTop: 7,
  }
  const styleSuccess = {
    background: '#2da888',
    color: '#fff',
    paddingTop: 7,
  }
  const styleError = {
    background: '#f94040',
    color: '#fff',
    paddingTop: 7,
  }

  const handleGetReviseSchema = async (proposalId) => {
    startLoading()
    try {
      const resp = await getProposalReviseNew(proposalId)
      //console.log('call api => ', JSON.stringify(resp))

      if (resp) {
        setReviseSchema(resp?.model?.forms?.ProjectFeedback?.revises)
        setShowDrawer(true)
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title:
          e?.response?.data?.errorMessage || e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
    }
    doneLoading()
  }

  const handleGetReviseContractSchema = async (proposalId) => {
    startLoading()
    try {
      const resp = await getEditContractRevise(proposalId)
      //console.log('call api => ', JSON.stringify(resp))

      if (resp) {
        setReviseSchema(resp?.model?.forms?.projectFeedback?.revises)
        setShowDrawer(true)
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title:
          e?.response?.data?.errorMessage || e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
    }
    doneLoading()
  }

  const onDownload = async (filePath) => {
    startLoading()
    try {
      var file = await downloadFileByPath(filePath)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'ข้อเสนอโครงการ')
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || 'ดาวน์โหลดไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const timelineWithIcon = () => {
    return (
      <Timeline align={'left'} className="custom-timeline">
        {formSchema?.projectTimeline?.value.map((item, index) => {
          let _style
          switch (item.icon) {
            case 'check':
              _style = styleSuccess
              break
            case 'edit':
              _style = styleError
              break
            default:
              _style = styleIcon
              break
          }
          return (
            <Timeline.Item
              key={index}
              dot={<Icon icon={item.icon || ''} size="lg" style={_style} />}
            >
              <p style={item.icon == 'edit' ? { color: '#f94040' } : null}>{item.label}</p>
              {item.link && (
                <p>
                  <Link onClick={() => onDownload(item.link)}>
                    ดาวน์โหลดข้อเสนอโครงการ v.{item.versionCode}
                  </Link>
                </p>
              )}
              {item.projectVersionId && (
                <p>
                  <Link
                    onClick={() => {
                      if (item.isProgress) {
                        handleGetReviseContractSchema(item.projectVersionId)
                      } else {
                        handleGetReviseSchema(item.projectVersionId)
                      }
                    }}
                  >
                    ดูประวัติการส่งกลับแก้ไข v.{item.versionCode}
                  </Link>
                </p>
              )}
              {item.comment && (
                <p>
                  <Link onClick={() => setShowComment(item.comment)}>
                    ดูความเห็น
                  </Link>
                </p>
              )}
              <p>{item.dateTime}</p>
            </Timeline.Item>
          )
        })}
      </Timeline>
    )
  }

  const progressVertical = () => {
    return (
      <Row>
        <Col xs={6}>
          <div className="line-vertical-wrapper" style={{ height: 300 }}>
            <Line
              vertical
              percent={formSchema.progressBarPercent}
              status="active"
              style={{ padding: '0px' }}
            />
          </div>
        </Col>
        <Col xs={18}>
          <Steps current={formSchema.progressCompleteStep?.currentStep} vertical>
            {formSchema?.progressCompleteStep?.value.map((item, index) => {
              return <Steps.Item key={index} title={item} style={{ marginBottom: 5 }} />
            })}
          </Steps>
        </Col>
      </Row>
    )
  }

  const timelineWithTime = () => {
    return (
      <Timeline align="left">
        {formSchema?.updateHistory?.value.map((item, index) => {
          return (
            <Timeline.Item key={index} time={item?.dateTime || ' '}>
              <Link to={item.link}>{item.label}</Link>
            </Timeline.Item>
          )
        })}
      </Timeline>
    )
  }

  return (
    <>
      <Panel bordered shaded>
        <Grid fluid style={{ margin: -20 }}>
          <Row>
            <Col lg={8} md={12} sm={24} xs={24}>
              <Panel header={formSchema.projectTimeline?.header} collapsible defaultExpanded>
                <div style={{ maxHeight: 900, overflowY: 'auto', overflowX: 'hidden' }}>
                  {timelineWithIcon()}
                </div>
              </Panel>
            </Col>

            <Col lg={8} md={12} sm={24} xs={24}>
              <Panel header={formSchema.progressCompleteStep?.header} collapsible defaultExpanded>
                <div
                  style={{
                    maxHeight: formSchema.progressClosureStep ? 600 : 900,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >
                  {progressVertical()}
                </div>
              </Panel>

              {formSchema.progressClosureStep && (
                <Panel header={formSchema.progressClosureStep?.header} collapsible defaultExpanded>
                  <div style={{ maxHeight: 600, overflowY: 'auto', overflowX: 'hidden' }}>
                    <Steps current={formSchema.progressClosureStep.currentStep} vertical>
                      {formSchema.progressClosureStep.value.map((item, index) => {
                        return (
                          <Steps.Item
                            //icon={<Icon icon={item.icon} size="2x" style={{ color: item.iconColor }}/>}
                            icon={
                              //index < formSchema.progressClosureStep.currentStep && (
                              item.icon ? (
                                <Icon
                                  icon={item.icon || undefined}
                                  size="2x"
                                  style={{ color: item.iconColor }}
                                />
                              ) : undefined
                              //)
                            }
                            key={index}
                            title={item.title}
                            description={item.desc}
                            style={{ marginBottom: 5 }}
                          />
                        )
                      })}
                    </Steps>
                  </div>
                </Panel>
              )}
            </Col>

            <Col lg={8} md={12} sm={24} xs={24}>
              <Panel header={formSchema.updateHistory?.header} collapsible defaultExpanded>
                <div style={{ maxHeight: 900, overflowY: 'auto', overflowX: 'hidden' }}>
                  {timelineWithTime()}
                </div>
              </Panel>
            </Col>
          </Row>
        </Grid>
      </Panel>

      <Drawer size={'lg'} placement={'top'} show={showDrawer} onHide={() => setShowDrawer(false)}>
        <Drawer.Header>
          <Drawer.Title>ประวัติการส่งกลับแก้ไข</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          {reviseSchema && <ProposalReviseView schema={reviseSchema} disabledForm={true} />}
        </Drawer.Body>
        <Drawer.Footer>
          <CancelButton onClick={() => setShowDrawer(false)} appearance="subtle">
            ปิด
          </CancelButton>
        </Drawer.Footer>
      </Drawer>
      
      <ConfirmWidget
        title={`ความเห็น`}
        show={showComment}
        detail={showComment}
        onCancle={() => setShowComment(false)}
        cancleBtn={'ปิด'}
        hideConfirm
        size='md'
        // onConfirm={handleOnConfirmDelete}
      />
    </>
  )
}
